import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { AppWidgetComponent } from './app-widget.component';
import { AppWidgetRoutingModule } from './app-widget-routing.module';
import { NgxsModule } from '@ngxs/store';
import { LayoutModule } from '../../layout/layout.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BookmarksModule } from '../../bookmarks/bookmarks.module';
import { EngineModule } from '../../engine/engine.module';
import { StoryModule } from '../../story/story.module';
import { OrganizationsModule } from '../../organizations/organizations.module';

import { HistoryModule } from '../../history/history.module';
import { LocaleConfigModule } from '../../locale-config.module';
import { DialogModule } from '../../dialogs/dialog.module';
import { ViewModule } from 'src/app/view/view.module';
import { ApiInterceptor } from 'src/app/interceptors/api.interceptor';
import { WidgetAuthModule } from 'src/app/widget-auth/widget-auth.module';
import { WidgetModule } from 'src/app/widget/widget.module';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { environment } from 'src/environments/environment';
import { UrlSerializer } from '@angular/router';
import { CustomUrlSerializer } from 'src/app/shared/libraries/url/custom-url-serializer';

const providers = [
  { provide: HTTP_INTERCEPTORS, useClass: ApiInterceptor, multi: true },
  { provide: UrlSerializer, useClass: CustomUrlSerializer }
];

@NgModule({
  declarations: [
    AppWidgetComponent
  ],

  imports: [
    // This has to be at the top due to a bug in NgxsOnInit (https://github.com/ngxs/store/issues/539)
    NgxsModule.forRoot(),
    // NgxsReduxDevtoolsPluginModule.forRoot({
    //   disabled: environment.production
    // }),
    // Locales
    LocaleConfigModule.forRoot(),

    // NoopAnimationsModule, // Disable animations for faster UI
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,

    // App dependencies
    EngineModule,

    // Child features
    BookmarksModule,
    HistoryModule,
    LayoutModule,
    OrganizationsModule,
    StoryModule,

    // Dialogs
    DialogModule,

    ViewModule,

    // Widget auth + analytics
    WidgetModule,
    WidgetAuthModule,

    // App routing
    AppWidgetRoutingModule
  ],
  providers: providers,
  bootstrap: [AppWidgetComponent]
})
export class AppWidgetModule { }
